var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "position-relative" }, [
    _vm.isShowMoreTabsContainer
      ? _c("div", {
          staticClass: "c-tabs-overlay",
          on: {
            click: function ($event) {
              _vm.isShowMoreTabsContainer = false
            },
          },
        })
      : _vm._e(),
    _vm.isShowLeftShadow
      ? _c("div", { staticClass: "c-tabs-left-shadow" })
      : _vm._e(),
    _c(
      "div",
      {
        staticClass: "c-tabs",
        attrs: { id: _vm.id ? _vm.id : "c-tabs-container" },
      },
      [
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "div",
            {
              directives: [
                {
                  name: "b-popover",
                  rawName: "v-b-popover.html",
                  value: {
                    container: "#app",
                    trigger: "hover blur",
                    boundary: "window",
                    content: item.label,
                    placement: "top",
                  },
                  expression:
                    "{\n        container: '#app',\n        trigger: 'hover blur',\n        boundary: 'window',\n        content: item.label,\n        placement: 'top',\n      }",
                  modifiers: { html: true },
                },
              ],
              key: item.value,
              staticClass: "c-tabs-item",
              class: {
                "c-tabs-item_active": _vm.isActive(item.value),
                "c-tabs-item_disabled": item.disabled,
              },
              attrs: {
                id: _vm.id ? `${_vm.id}-c-tab-${index}` : `c-tab-${index}`,
              },
              on: { click: (e) => _vm.selectTab(e, item) },
            },
            [
              _c("div", { staticClass: "c-tabs-item-label" }, [
                _vm._v(_vm._s(item.label)),
              ]),
            ]
          )
        }),
        _vm.isShowMoreTabsButton
          ? _c(
              "div",
              {
                staticClass: "c-tabs-item c-tabs-item-more",
                class: {
                  "c-tabs-item_active": false,
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "c-tabs-item-label",
                    on: {
                      click: function ($event) {
                        _vm.isShowMoreTabsContainer =
                          !_vm.isShowMoreTabsContainer
                      },
                    },
                  },
                  [_vm._v("Ещё..")]
                ),
                _vm.isShowMoreTabsContainer && _vm.moreTabs.length > 0
                  ? _c("div", { staticClass: "c-tabs-item-more-container" }, [
                      _c(
                        "div",
                        { staticClass: "c-tabs-item-more-container-list" },
                        _vm._l(_vm.moreTabs, function (moreTab, index) {
                          return _c(
                            "div",
                            {
                              key: `tabs-${index}`,
                              staticClass:
                                "c-tabs-item-more-container-list-item",
                              class: {
                                "c-tabs-item-more-container-list-item-active":
                                  _vm.isActive(moreTab.value),
                              },
                              on: { click: (e) => _vm.selectTab(e, moreTab) },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-tabs-item-more-container-list-item-label",
                                },
                                [_vm._v(" " + _vm._s(moreTab.label) + " ")]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ],
      2
    ),
    _vm.isShowRightShadow
      ? _c("div", { staticClass: "c-tabs-right-shadow" })
      : _vm._e(),
    _c("div", { staticClass: "c-tabs-shadow" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }